import type { PopupEvent, PopupRuntimeContext } from "./types";
import type { PopupTrackRequest } from "../utils/rendererApi";

export const buildPopupTrackRequest = ({
  ctx,
  popupId,
  event,
}: {
  ctx: PopupRuntimeContext;
  popupId: string;
  event: PopupEvent;
}): PopupTrackRequest | null => {
  if (!ctx.siteId) return null;

  return {
    channelId: ctx.siteId,
    popupId,
    event,
    pageSlug: ctx.currentSlug || "/",
    pageTitle: ctx.currentPageTitle || undefined,
  };
};
